import React from "react";
import Footer from "../../components/layout/Footer/Footer";
import Overlay from "../../components/layout/Overlay";
import {ChildrenProps} from "../../utils";
import {Content, Main, ModalContainer, ScrollToTopButton} from "../../components";
import {HeaderPublic} from "../../components/layout/HeaderNew";

const LayoutPublic = ({children}: ChildrenProps) => {
  return (
    <>
      <Content>
        <HeaderPublic/>
        <Overlay />
        <Main>
          {children}
        </Main>
        <Footer />
        <ModalContainer />
        <ScrollToTopButton />
      </Content>
    </>
  );
};

export default LayoutPublic;